import API from 'util/API';

/**
 * Restaurant API functions
 */

// Get all restaurants
export const getRestaurants = async () => {
  try {
    // console.log('Fetching restaurants from API...');
    const response = await API.get('/restaurants', {
      timeout: 30000 // 30 seconds timeout
    });
    // console.log('Restaurants API response:', response);
    return response.data;
  } catch (error) {
    console.error('Error in getRestaurants:', {
      message: error.message,
      response: error.response,
      status: error.response?.status
    });
    throw error;
  }
};

// Get restaurant by ID (plural endpoint)
export const getRestaurant = async (restaurantId) => {
  const response = await API.get(`/restaurants/${restaurantId}`);
  return response.data;
};

// Get restaurant by ID (singular endpoint)
export const getRestaurantById = async (restaurantId) => {
  const response = await API.get(`/restaurant/${restaurantId}`);
  return response.data;
};

// Update restaurant by ID (singular endpoint)
export const updateRestaurantById = async ({ restaurantId, data }) => {
  const response = await API.put(`/restaurant/${restaurantId}`, data);
  return response.data;
};

// Create restaurant (singular endpoint)
export const createRestaurantById = async (data) => {
  const response = await API.post(`/restaurant`, data);
  return response.data;
};

// Create new restaurant
export const createRestaurant = async (restaurantData) => {
  const response = await API.post('/restaurants', restaurantData);
  return response.data;
};

// Update restaurant
export const updateRestaurant = async ({ restaurantId, ...restaurantData }) => {
  const response = await API.put(`/restaurants/${restaurantId}`, restaurantData);
  return response.data;
};

// Delete restaurant
export const deleteRestaurant = async (restaurantId) => {
  const response = await API.delete(`/restaurants/${restaurantId}`);
  return response.data;
};

// Get restaurant settings
export const getRestaurantSettings = async (restaurantId) => {
  const response = await API.get(`/restaurants/${restaurantId}/settings`);
  return response.data;
};

// Update restaurant settings
export const updateRestaurantSettings = async ({ restaurantId, ...settings }) => {
  const response = await API.put(`/restaurants/${restaurantId}/settings`, settings);
  return response.data;
};

// Send invoice email
export const sendInvoiceEmail = async ({ yearMonthStr, transactionDateStr, email, transactionId }) => {
  const response = await API.post('/sendInvoiceEmail', {
    yearMonthStr,
    transactionDateStr,
    email,
    transactionId
  });
  return response.data;
};

